export const declineBidOptions = [
  'We don\'t offer discounted corporate rates.',
  'We have tried offering rate discounts to this company in the past, but we saw very little production.',
  'The overall Bid Package does not fit well with our type of hotel.',
  'We simply don\'t know enough about this company.',
  'Projected Room night volume does not meet our minimum standards for a discounted rate.',
  'This bid is from a company that our National Sales team typically handles.',
];
